import { TokenSet } from 'auth0';

export const MOBILE_VERIFIED_KEY = '@@marketplace-mobile-verified@@';

type MobileVerifiedToken =
  | TokenSet
  | { access_token?: string; id_token?: string; expires_in?: number; token_type?: string };

export const getMobileVerifiedToken = () => {
  try {
    const cached = localStorage.getItem(MOBILE_VERIFIED_KEY);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    return parsed as { token: MobileVerifiedToken; phone: string; expiresAt: number };
  } catch {
    return null;
  }
};

export const setMobileVerifiedToken = (token: MobileVerifiedToken, phone: string) => {
  const expiresAt = Date.now() + (token.expires_in ?? 1800) * 1000;
  localStorage.setItem(MOBILE_VERIFIED_KEY, JSON.stringify({ token, phone, expiresAt }));
};

export const removeMobileVerifiedToken = () => {
  localStorage.removeItem(MOBILE_VERIFIED_KEY);
};
